import { MantineTheme, rem } from "@mantine/styles";

import { ThemeComponent } from "./helpers.ts";

export default function navLinkTheme(): ThemeComponent {
  return {
    styles: (theme: MantineTheme) => ({
      root: {
        color: theme.colors.white[0],
        fontSize: rem(16),
        lineHeight: 1.55,
        borderRadius: rem(4),
        gap: rem(12),
        height: rem(44),
        alignItems: "center",
        minWidth: rem(44),
        padding: `${rem(8)} ${rem(10)}`,

        "&:hover": {
          background: "inherit",
          color: theme.colors.golden[0],
        },

        "&[data-active]": {
          background: "inherit",
          color: theme.colors.golden[0],

          "&:hover": {
            background: "inherit",
            color: theme.colors.golden[0],
          },
        },
      },
    }),
  };
}
